/**
 * Country Resource Hooks
 */

import type { paths } from '@access-cms/api-types';

import type { QueryParamRecord } from '../../types';
import { useApiList } from '../useApiQuery';

type CountryListResponse = paths['/api/v1/countries']['get']['responses']['200']['content']['application/json'];
type CountryListFilters = paths['/api/v1/countries']['get']['parameters']['query'];
type Country = NonNullable<NonNullable<CountryListResponse['data']>[number]>;

interface UseCountriesQueryOptions {
  enabled?: boolean;
  excludeUs?: boolean;
  search?: string;
}

const countryQueryKeys = {
  list: (filters?: QueryParamRecord) => ['countries', 'list', filters ?? {}] as const,
};

export function useCountriesQuery(options?: UseCountriesQueryOptions) {
  const queryParams: CountryListFilters = {
    ...(options?.excludeUs !== undefined ? { excludeUs: options.excludeUs ? 'true' : 'false' } : {}),
    ...(options?.search ? { search: options.search } : {}),
  };

  return useApiList('/api/v1/countries', {
    enabled: options?.enabled,
    queryKey: countryQueryKeys.list(queryParams as QueryParamRecord),
    queryParams,
  });
}

export type { Country, CountryListFilters, CountryListResponse };
